'use client';

import React, { useState } from 'react';
import InfoCircle from '@clayton-homes/ui-icons/24/info-circle';

const ToolTipWindow = ({ children }: { children: React.ReactNode }) => (
  <div className="absolute bottom-7 left-0 z-10 min-h-[200px] min-w-[350px] bg-white shadow-component">
    {children}
  </div>
);

export const Tooltip = ({
  text,
  children,
}: {
  text: string;
  children?: React.ReactNode;
}) => {
  const [showTooltipWindow, setShowTooltipWindow] = useState<true | false>(
    false
  );

  const handleToolTipClick = () => { setShowTooltipWindow(!showTooltipWindow); };

  return (
    <div
      className="relative w-fit"
      onClick={handleToolTipClick}
      onMouseEnter={() => setShowTooltipWindow(true)}
      onMouseLeave={() => setShowTooltipWindow(false)}
    >
      {showTooltipWindow && <ToolTipWindow>{children}</ToolTipWindow>}
      <div className="inline-flex w-full items-center text-[12px] text-gray-500 hover:cursor-pointer">
        <InfoCircle className="mr-1 h-4 w-4" />
        {text?.trim() && text.trim()}
      </div>
    </div>
  );
};
